export const FETCH_CORE_COMPONENTS_REQUEST = 'FETCH_CORE_COMPONENTS_REQUEST';
export const FETCH_CORE_COMPONENTS_SUCCESS = 'FETCH_CORE_COMPONENTS_SUCCESS';
export const FETCH_CORE_COMPONENTS_ERROR = 'FETCH_CORE_COMPONENTS_ERROR';
export const UPSERT_CORE_COMPONENT_REQUEST = 'UPSERT_CORE_COMPONENT_REQUEST';
export const UPSERT_CORE_COMPONENT_SUCCESS = 'UPSERT_CORE_COMPONENT_SUCCESS';
export const UPSERT_CORE_COMPONENT_ERROR = 'UPSERT_CORE_COMPONENT_ERROR';
export const DELETE_CORE_COMPONENT_REQUEST = 'DELETE_CORE_COMPONENT_REQUEST';
export const DELETE_CORE_COMPONENT_SUCCESS = 'DELETE_CORE_COMPONENT_SUCCESS';
export const DELETE_CORE_COMPONENT_ERROR = 'DELETE_CORE_COMPONENT_ERROR';
export const UPDATE_CURRENT_AOR_REQUEST = 'UPDATE_CURRENT_AOR_REQUEST'
export const UPDATE_CURRENT_AOR_SUCCESS = 'UPDATE_CURRENT_AOR_SUCCESS'
export const UPDATE_CURRENT_AOR_ERROR = 'UPDATE_CURRENT_AOR_ERROR'
